import { Component, OnInit, ViewChild } from '@angular/core';

import { ClienteService } from '../services/cliente.service';
import { ListadoClientes } from '../models/viewmodels/listadoClientes';
import { ClienteViewModel } from '../models/viewmodels/clienteViewModel';
import { Router } from '@angular/router'
import { DoubleBounceComponent } from '../shared/spinners/double-bounce/double-bounce.component'
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './clientes-layout.component.html'
})
export class ClientesLayoutComponent implements OnInit {

    clientes: Array<ClienteViewModel> = [];
    username: string;
    multiRol:boolean = false;
    kairos:boolean = false; 
    

    constructor(private clienteService: ClienteService, private router: Router, private authService: AuthService) {
        this.kairos = environment.kairos;
    }

    ngOnInit(): void {
        this.username = this.authService.username;        
        this.multiRol = this.authService.roles.indexOf("intranet") > -1 && this.authService.roles.indexOf("usuario") > -1;
        if(!this.multiRol){
            this.toggleClass(document.querySelector('body'), 'sidebar-off-canvas');
        }

        if(this.router.url === '/clientes'){
            this.clienteService.listado(0, 10, "").subscribe(result => {                            
                if(result.clientes.length > 0){
                    this.removeClass(document.querySelector('body'), 'sidebar-off-canvas');
                    this.clienteService.clientesUsuario = result.clientes;
                    this.clientes = result.clientes;
                    this.clienteService.setCliente(this.clientes[0]);
                    this.router.navigate(['clientes/ctacte/aplicada']);
                }else if(this.authService.roles.indexOf("intranet") > -1){
                    this.router.navigate(['intranet/kairos']);
                }else{
                    this.logout();
                }
            });
        }
    }

    logout() {
        this.authService.logout();
        this.router.navigate(['login']);
    }
    
    private toggleClass(elem: any, elementClassName: string) {
        let newClass = ' ' + elem.className.replace(/[\t\r\n]/g, ' ') + ' ';
        if (!this.hasClass(elem, elementClassName)) {
            elem.className += ' ' + elementClassName;
        }
    }

    private removeClass(elem: any, elementClassName: string) {
        elem.className += elem.className.replace(elementClassName, '');
    }

    private hasClass(target: any, elementClassName: string) {
        return new RegExp('(\\s|^)' + elementClassName + '(\\s|$)').test(target.className);
    }
    
    private clienteChange(id:string){
        var cliente = this.clientes.find((c) => {
            return c.id === id
        });
        this.clienteService.setCliente(cliente);
    }

}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/layouts/clientes-layout.component.ts